var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatConversation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H10C10.1326 4 10.2598 4.05268 10.3536 4.14645C10.4473 4.24022 10.5 4.36739 10.5 4.5V10L8.8335 8.6155C8.74357 8.54085 8.63037 8.5 8.5135 8.5H4.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355C4.05268 8.25979 4 8.13261 4 8V6.5M8 4V2.5C8 2.36739 7.94732 2.24021 7.85355 2.14645C7.75979 2.05268 7.63261 2 7.5 2H2C1.86739 2 1.74021 2.05268 1.64645 2.14645C1.55268 2.24021 1.5 2.36739 1.5 2.5V8L3.1665 6.615C3.2565 6.541 3.3695 6.5 3.4865 6.5H4M8 4V6C8 6.13261 7.94732 6.25979 7.85355 6.35355C7.75979 6.44732 7.63261 6.5 7.5 6.5H4",
    stroke: "#444746",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatConversation);
export default __webpack_public_path__ + "static/media/chat-conversation.39bb6a6f4b72a5a2019119833e359f1e.svg";
export { ForwardRef as ReactComponent };